import {
  HUSST_SORT_GROUPS_WITH_TICKET_DATA,
  ISortGroupWithTicketData,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../app-config.service';
import { inject } from '@angular/core';

export class SortGroupsTicketDataGateway {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly restCallBuilder: RestCallBuilder<
    ISortGroupWithTicketData[]
  > = new RestCallBuilder<ISortGroupWithTicketData[]>([]);

  list(
    serviceAreaId: number,
    hasToBeActive = false
  ): Observable<IApiResponse<ISortGroupWithTicketData[]>> {
    return this.restCallBuilder
      .getExternal(
        this.configService.get().general.directTicketUrl +
          '/tickets/sort-groups',
        {
          serviceAreaId,
          hasToBeActive,
        }
      )
      .validate(
        API_RESPONSE_SCHEMA(HUSST_SORT_GROUPS_WITH_TICKET_DATA),
        'SortGroupsTicketData.list'
      )
      .handleMessages(undefined, true)
      .build();
  }
}
